import {colors} from "@c10h/colors";
import React, {memo} from "react";

type Props = {
  toggle?: boolean;
  size?: number;
  className?: string;
  style?: Omit<React.CSSProperties, "height" | "width">;
  color?: string;
  transitionTime?: 100 | 150 | 200 | 250 | 300;
};

const PlusMinus: React.FC<Props> = ({
  toggle = false,
  size = 20,
  className,
  style = {},
  color = colors.gray800,
  transitionTime = 200,
}) => (
  <div
    aria-hidden
    className={`pos-r ${className || ""}`}
    style={{
      height: size,
      width: size,
      ...style,
    }}
  >
    <span
      className={`pos-a left0 right0 ma br2 contrast-tb t-${transitionTime}`}
      style={{
        height: size,
        width: size * 0.1,
        backgroundColor: color,
        WebkitTransform: toggle ? "scale(0, 0)" : null,
        transform: toggle ? "rotate(0deg) scale(0%)" : "rotate(-90deg)",
      }}
    />
    <span
      className={`pos-a left0 right0 ma br2 contrast-tb t-${transitionTime}`}
      style={{
        height: size,
        width: size * 0.1,
        backgroundColor: color,
        transform: toggle ? "rotate(90deg)" : "rotate(0deg)",
      }}
    />
  </div>
);

export default memo(PlusMinus);
